import React, { useEffect, useState } from "react";
import { Header, Button } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import Wordcloud from "../components/Wordcloud";
import KeywordFrequencyTable from "../components/KeywordFrequencyTable";
import { useLocation, useNavigate } from "react-router-dom";
import { fileNamePatternSentiment, intentDetailTypeData, fileNamePatternIntent, intentTypeData, sentimentTypeData } from '../data/dummy';
import html2canvas from 'html2canvas'; // 추가
import axios from 'axios';
import Papa from 'papaparse';

const VisualizeWordcloudDetail = () => {
  const { currentColor } = useStateContext();
  const [unixTime, setUnixTime] = useState('');
  const [userId, setUserId] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [sdata, setData] = useState(null);

  const fileUrls = [
    'network_pos_1_a_1732515483.csv',
    'network_pos_1_b_1732515483.csv',
    'network_pos_1_c_1732515483.csv',
    'network_pos_2_a_1732515483.csv',
    'network_pos_2_b_1732515483.csv',
    'network_pos_2_c_1732515483.csv',
    'network_pos_3_a_1732515483.csv',
    'network_pos_3_b_1732515483.csv',
    'network_pos_3_c_1732515483.csv',
    'network_pos_4_a_1732515483.csv',
    'network_pos_4_b_1732515483.csv',
    'network_pos_4_c_1732515483.csv'
  ];

  // 키워드별 색상 상태 관리 (상위 페이지에서 받은 상태로 초기화)
  const [keywordColors, setKeywordColors] = useState(location.state?.keywordColors || {});

  const [intentName, setIntentName] = useState(location.state?.intentName || "");
  const [sentiment, setSentiment] = useState(location.state?.sentiment || "");
  
  const downloadChartAsImage = async (chartId, fileName) => {
    const chartElement = document.getElementById(chartId); // 캡처할 차트의 DOM 요소
    if (!chartElement) {
      console.error(`Element with ID ${chartId} not found`);
      return;
    }

    try {
      const canvas = await html2canvas(chartElement, { scale: 2 }); // 캔버스로 렌더링
      const link = document.createElement('a');
      link.download = `${fileName}.png`; // 파일 이름
      link.href = canvas.toDataURL('image/png'); // 캡처된 이미지를 PNG로 변환
      link.click(); // 다운로드 실행
    } catch (error) {
      console.error('Error capturing chart:', error);
    }
  };

  // 색상 변경 핸들러
  const handleColorChange = (keyword, color) => {
    setKeywordColors((prevColors) => ({
      ...prevColors,
      [keyword]: color, // 특정 키워드에 색상 적용
    }));
  };

  // 이전 페이지로 돌아가기
  const goBack = () => {
    console.log("이전 페이지 이동 버튼 클릭");
    navigate("/vis/wordcloud", { state: { keywordColors } }); // 변경된 색상 상태 전달
  };

  useEffect(() => {
    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);
  }, [])

  return (
    <div className="m-2 md:m-10 mt-0 p-2 md:p-10 bg-white rounded-3xl">
      <Button
        color="white"
        bgColor={currentColor}
        text="이전 페이지"
        borderRadius="10px"
        onClick={goBack}
      />
      <div className="flex gap-5">
        <Header
          category="데이터 시각화"
          title={`상세 조회 페이지 - ${intentName} 리뷰`}
        />
      </div>

      {intentDetailTypeData[intentName].map((intentDetailName, index) => (
        <div>
          <p className="text-xl font-semibold">{intentDetailName} 리뷰</p><br />
          <div className="flex gap-5">
            {sentimentTypeData.map((sentiment, index) => (
              <div className="flex-1">
                <div className="flex gap-3 items-center">
                  <p className="text-s font-semibold">{sentiment} 리뷰</p>
                  {/* <Button
                    color="white"
                    bgColor={currentColor}
                    text="편집하기"
                    borderRadius="10px"
                    onClick={() => navigate('/vis/wordcloud-detail-edit',
                      { state: { intentName, intentDetailName, sentiment } })}
                  /> */}
                  <Button
                    color="white"
                    bgColor={currentColor}
                    text="다운로드(.png)"
                    borderRadius="10px"
                    onClick={() => downloadChartAsImage('wordcloud-container-pos',
                      `워드클라우드_${intentName}_${intentDetailName}_${sentiment}`)} // 다운로드 핸들러
                  />
                </div>
                <br />
                <div id={"wordcloud-container-pos"}>
                  <Wordcloud intent={intentDetailName} sentiment={sentiment} 
                              pageType={"전체"} keywordColors={keywordColors} />
                </div>
              </div>
            ))}
            

          </div>
          <hr className="my-8 border-gray-300" />
        </div>
      ))}
    </div>
  );
};

export default VisualizeWordcloudDetail;
